import * as React from "react";
import { useEffect, useState } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { chevronDownIcon } from "@progress/kendo-svg-icons";
import { getTeams } from "api";
import { ComboBoxLabel } from "components/Dashboard";
import { useCurrentUser } from "services/currentUserService";
import { useCompany } from "services/companyService";
import { DateRange } from "./DateRange";
import { formatDateForAPI } from "./formatter";

export const FilterComponent = (props) => {
  const { data: user } = useCurrentUser();
  const INITIAL_STATE = {
    branchId: {
      branchName: "ALL",
      branchId: props?.allowAccessData?.accessAllBranches
        ? -2
        : props?.allowAccessData?.accessAllTeams
          ? props?.allowAccessData?.branches[0]?.branchId
          : -1,
    },
    teamId: { teamName: "ALL", teamID: -2 },
    feeEarnerRef: {
      display: user?.display || "ALL",
      userRef: user?.userRef || "ALL",
      active: null,
    },
  };
  const { data: company } = useCompany();

  const startDate = new Date(company?.yearStartDate);
  let startOfWeek, endOfWeek;
  const dayOfWeek = startDate.getDay();
  startOfWeek = new Date(startDate);
  startOfWeek.setDate(
    startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1),
  );
  endOfWeek = new Date(startOfWeek);
  endOfWeek.setFullYear(startOfWeek.getFullYear() + 1);
  endOfWeek.setDate(endOfWeek.getDate() - 1);

  const [teamsData, setTeamsData] = useState([]);
  const [comboBoxState, setComboBoxState] = useState(INITIAL_STATE);
  const [initialLock, setInitialLock] = useState(true);
  const [duration, setDuration] = useState("");
  const [toDate, setToDate] = useState(endOfWeek);
  const [fromDate, setFromDate] = useState(startOfWeek);

  useEffect(() => {
    if (!initialLock) {
      props.updateFilters({
        feeEarnerRef: comboBoxState["feeEarnerRef"]?.userRef || user?.userRef,
        teamId: comboBoxState["teamId"]?.teamID,
        branch: comboBoxState["branchId"]?.branchId,
        ToDate: formatDateForAPI(toDate),
        FromDate: formatDateForAPI(fromDate),
        duration: duration,
      });
    }

    if (initialLock) setInitialLock(false);
  }, [comboBoxState, toDate, fromDate]);

  useEffect(() => {
    if (user) {
      setComboBoxState({
        ...comboBoxState,
        feeEarnerRef: {
          display: user?.display || "ALL",
          userRef: user?.userRef || "ALL",
          active: null,
        },
      });
    }
  }, [user]);

  const dataFetcher = async (e) => {
    try {
      const data = await getTeams();
      let dataToPass = data?.data?.data;
      setTeamsData([{ teamName: "All" }, ...dataToPass]);
    } catch (error) { }
  };
  useEffect(() => {
    dataFetcher();
  }, []);

  const DASHBOARD_FILTERS = props.component === "Dashboard";
  const inlineLayout = props.inlineLayout === true;

  const filterColClass = DASHBOARD_FILTERS
    ? "col-sm-12 col-md-6 col-lg-4 col-xl-3"
    : "col";

  const toolbarFilterStyle = !DASHBOARD_FILTERS
    ? { minWidth: "175px", maxWidth: "225px", flexShrink: 0 }
    : undefined;

  const handleDateChange = (newFromDate, newToDate, newDuration) => {
    setFromDate(newFromDate);
    setToDate(newToDate);
    setDuration(newDuration);
  };

  const filterContent = (
    <>
      {props?.allowAccessData?.accessAllBranches && (
        <div
          className={`d-flex flex-column ${filterColClass}`}
          style={toolbarFilterStyle}
        >
          {DASHBOARD_FILTERS ? (
            <ComboBoxLabel name="Branch" />
          ) : (
            <Label className="filter-font mb-1">Branch</Label>
          )}
          <ComboBox
            style={{
              width: "100%",
              height: "40px",
            }}
            data={[
              // { branchName: "ALL", branchId: -2 },
              ...(props?.allowAccessData?.branches || [])
            ]}
            textField={`branchName`}
            className="ps-2"
            svgIcon={chevronDownIcon}
            filterable={true}
            dataItemKey="branchId"
            placeholder={"Search Branch"}
            value={comboBoxState["branchId"]}
            onChange={(e) => {
              if (e.value === null) {
                setComboBoxState({
                  ...comboBoxState,
                  branchId: { branchName: "ALL", branchId: -2 },
                });
                return;
              }
              setComboBoxState({ ...comboBoxState, branchId: e.value });
            }}
          />
        </div>
      )}

      {(!props?.allowAccessData?.accessAllTeams &&
        props?.allowAccessData?.branches[0]?.teams?.length > 1) ||
        (props?.allowAccessData?.accessAllTeams && (
          <div
            className={`d-flex flex-column ${filterColClass}`}
            style={toolbarFilterStyle}
          >
            {DASHBOARD_FILTERS ? (
              <ComboBoxLabel name="Team" />
            ) : (
              <Label className="filter-font mb-1">Team</Label>
            )}
            <ComboBox
              style={{
                height: "40px",
                width: "100%",
              }}
              data={[
                { teamName: "ALL", teamID: -2 },
                ...(props.allowAccessData?.branches?.filter(
                  (branch) =>
                    branch.branchId === comboBoxState["branchId"]?.branchId,
                )[0]?.teams?.filter(team => team.teamName !== "ALL") || [])
              ]}
              dataItemKey="teamID"
              svgIcon={chevronDownIcon}
              textField={"teamName"}
              value={comboBoxState["teamId"]}
              onChange={(e) => {
                if (e.value === null) {
                  setComboBoxState({
                    ...comboBoxState,
                    teamId: { teamName: "ALL", teamID: -2 },
                  });
                  return;
                }
                setComboBoxState({
                  ...comboBoxState,
                  teamId: e.value,
                });
              }}
              placeholder={"Search Team"}
            />
          </div>
        ))}

      {props?.allowAccessData?.accessAllFeeEarnersInTeam &&
        !props.disabledFeeEarner && (
          <div
            className={`d-flex flex-column ${filterColClass}`}
            style={toolbarFilterStyle}
          >
            {DASHBOARD_FILTERS ? (
              <ComboBoxLabel name="Feeearner" />
            ) : (
              <Label className="filter-font mb-1">Fee Earner</Label>
            )}
            <ComboBox
              style={{
                width: "100%",
                height: "40px",
              }}
              data={[
                { display: "ALL", userRef: "ALL", active: null },
                ...(props.allowAccessData?.branches
                  ?.filter(
                    (branch) =>
                      branch.branchId === comboBoxState["branchId"]?.branchId,
                  )[0]
                  ?.teams.filter(
                    (teams) => teams.teamID === comboBoxState["teamId"]?.teamID,
                  )[0]
                  ?.feeEarners?.filter(feeEarner => feeEarner.userRef !== "ALL")
                  ?.map((feeEarner) => ({
                    ...feeEarner,
                    display: feeEarner?.displayname
                      ? `${feeEarner?.userRef} - ${feeEarner?.displayname}`
                      : feeEarner?.userRef,
                  })) || [])
              ]}
              textField="display"
              filterable={true}
              className="ps-2"
              dataItemKey="userRef"
              svgIcon={chevronDownIcon}
              placeholder={"Search Fee Earner"}
              value={comboBoxState["feeEarnerRef"]}
              onChange={(e) => {
                if (e.value === null) {
                  setComboBoxState({
                    ...comboBoxState,
                    feeEarnerRef: { display: "ALL", userRef: "ALL" },
                  });
                  return;
                }
                setComboBoxState({
                  ...comboBoxState,
                  feeEarnerRef: e.value,
                });
              }}
            />
          </div>
        )}

      {DASHBOARD_FILTERS && (
        <div className={`d-flex flex-column ${filterColClass}`}>
          <DateRange
            fromDate={fromDate}
            toDate={toDate}
            onDateChange={handleDateChange}
            yearStartDate={company?.yearStartDate}
            yearEndDate={company?.yearEndDate}
            icon
            fillWidth
            style={{ width: "100%", maxWidth: "326px", height: "40px" }}
            dropdownItems={[
              "Today",
              "This Week",
              "Past Week",
              "This Month",
              "Quarter",
              "Financial Year",
              "Calendar Year",
            ]}
          />
        </div>
      )}
    </>
  );

  if (inlineLayout) {
    return filterContent;
  }

  return (
    <div className="row g-2 align-items-end flex-wrap">{filterContent}</div>
  );
};
